import { Divider } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DropDownOption, useModal } from '@shape-ds/components';
import { useFeatureFlag } from '@shape/feature-flag';
import { useAuthentication } from 'hooks';
import Notifications from 'components/Notifications/Notifications';
import { LanguageSelector } from '../components';
import { NotificationsManager } from 'components/NotificationsManager/NotificationsManager';

export const useUserMenu = () => {
  const { logout, username } = useAuthentication();
  const { openModal } = useModal();
  const { t } = useTranslation();
  const isModec = useFeatureFlag('is-modec');
  const showNotifications = useFeatureFlag('feat-notifications');
  const isNewNotifications = useFeatureFlag('new-notifications');
  const handleLogout = useCallback(() => {
    logout();
  }, []);

  const dropDownOptions: DropDownOption[] = showNotifications
    ? [
        {
          label: t('components:header.user_menu.notifications'),
          onClick: () => {
            if (isNewNotifications) {
              return openModal(<NotificationsManager />, {
                width: '840px',
                className: 'notifications-manager-modal',
              });
            }
            return openModal(<Notifications />, {
              title: t('components:notifications.title'),
              className: 'notifications-modal',
              width: '970px',
            });
          },
        },
        { label: t('components:header.user_menu.exit'), onClick: handleLogout },
      ]
    : [{ label: t('components:header.user_menu.exit'), onClick: handleLogout }];

  const helpText = t('components:header.user_menu.help');
  const serviceDeskPortal = 'https://shapedigital.atlassian.net/servicedesk/customer/portal';
  const helpLink = isModec ? `${serviceDeskPortal}/36` : `${serviceDeskPortal}/37`;

  return {
    dropDownOptions,
    username,
    helpText,
    helpLink,
    customOptions: [<LanguageSelector key={1} />, <Divider key={2} />],
  };
};
